import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConcretePourService } from '../../../../../services/concrete-pour.service';
import { concretepour } from '../../../../../models/concretepour';
import { weather } from '../../../../../models/weather';
import { JobService } from '../../../../../services/job.service';
import * as moment from 'moment';
import { SnotifyService } from 'ng-snotify';
import { UUID } from 'angular2-uuid';
import { concretepourrecord } from '../../../../../models/concretepourrecord';


@Component({
  selector: 'app-concrete-pour-review-manage-review',
  templateUrl: './concrete-pour-review.component.html',
  styleUrls: ['./concrete-pour-review.component.scss']
})
export class ConcretePourManageReviewComponent implements OnInit {
  id: string;
  jobId: string;
  inspection: concretepour;
  weather: weather[];
  compaction: [];
  ButtonMsg: string = "Update";
  displayRemoveDialog: boolean = false;
  editing: boolean = false;
  fromPage: string = "";
  constructor(private route: ActivatedRoute, private router: Router, public concretePourService: ConcretePourService,
    private jobService: JobService, private snotifyService: SnotifyService) {
    this.inspection = new concretepour();
    this.inspection.concretePours = [];
    jobService.getWeather().then((data) => {
      this.weather = data;
    });

    jobService.getCompactionMethods().then((data) => {
      this.compaction = data;
    });
  }

  cancel() {
    this.displayRemoveDialog = false;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(async (paramsMap) => {
      var id = paramsMap.get("id");
      var jobId = paramsMap.get("jobId");

      if (id == "create")
        id = null;

      if (jobId != null && id == null)
        this.fromPage = "/scheduler";
      else if (jobId == null && id != null)
        this.fromPage = "/reports/concretepour";
      else
        this.fromPage = "/reviews/manage"

      if (id != null && id != "create") {
        console.log("KC LOOK HERE BABY");
        this.editing = true;
        this.concretePourService.get(id).then((data) => {
          this.jobId = data.jobId;
          for (var a = 0; a < data.concretePours.length; a++) {
            var p = data.concretePours[a];
            p.batchTime = moment(p.batchTime + 'Z').toDate();
            p.endTime = moment(p.endTime + 'Z').toDate();
            p.onSite = moment(p.onSite + 'Z').toDate();
            p.pour_Date = moment(p.pour_Date + 'Z').toDate();
            p.startTime = moment(p.startTime + 'Z').toDate();

            if (!this.checkNum(p.flow))
              p.flow = undefined;
            if (!this.checkNum(p.sump))
              p.sump = undefined;
            if (!this.checkNum(p.void))
              p.void = undefined;
            if (!this.checkNum(p.concrete_Temp))
              p.concrete_Temp = undefined;
          }

          this.inspection = data;
        });
      }

      if (id != null && id != "create") {
        this.id = id;
      } else{
        this.ButtonMsg = "Save";
        this.jobId = jobId;
        if (this.inspection.jobId == null)
          this.inspection.jobId = this.jobId;

        this.add();
      }
    });
  }
  add() {
    //console.log("Adding");
    //console.log(this.inspection.concretePours);
    //console.log(this.inspection.concretePours.length);
    var p = new concretepourrecord();
    p.id = UUID.UUID();
    p.position = this.inspection.concretePours.length + 1;

    if (this.inspection.concretePours.length > 0) {
      var previous = this.inspection.concretePours[this.inspection.concretePours.length - 1];
      //console.log(previous);
      p.concretePourInspectionId = this.inspection.id;
      p.pour_Date = previous.pour_Date;
      p.air_Temp = previous.air_Temp;
      p.concrete_Temp = previous.concrete_Temp;
      p.weatherId = previous.weatherId;
      p.compactionId = previous.compactionId;
      p.concreteStrength = previous.concreteStrength;
      p.plant_Num = previous.plant_Num;
      p.delivery_Number = previous.delivery_Number;
      p.cube_Set_Ref = previous.cube_Set_Ref;
      p.batchTime = previous.batchTime;
      p.onSite = previous.onSite;
      p.pour_Date = previous.pour_Date;
      p.startTime = previous.startTime;
      p.endTime = previous.endTime;
    }

    p.batchTime = moment().toDate();
    p.onSite = moment().toDate();
    p.pour_Date = moment().toDate();
    p.startTime = moment().toDate();
    p.endTime = moment().toDate();
    this.inspection.concretePours.push(p);
    //console.log(this.inspection.concretePours);
  }

  amountPouredChanged() {
    var total = 0; 
    for (var a = 0; a < this.inspection.concretePours.length; a++) {
      var p = this.inspection.concretePours[a];
      total += p.amount_Poured;
      p.total_Amount_Poured = total;
    }
  }
  setTechnician(technician) {
    this.inspection.userId = technician.id;
    this.inspection.technician = technician;
  }
  setConcreteStrength(pour, strength) {
    //console.log(strength);
    pour.concreteStrength = strength;
  }
  pourToBeRemoved: any;
  removeRow(pp) {
    this.pourToBeRemoved = pp;
    this.displayRemoveDialog = true;

  }
  confirmRemoval() {
    //console.log(this.pourToBeRemoved);
    var idx = 0;
    for (var i = 0; i < this.inspection.concretePours.length; i++) {
      var p = this.inspection.concretePours[i];
      if (p.id == this.pourToBeRemoved.id)
        idx = i;
    }
    this.inspection.concretePours.splice(idx, 1);
    this.displayRemoveDialog = false;
  }
  cancelRemoval() {
    this.displayRemoveDialog = false;
  }
  checkDate(val) {
    if (val == null || val == undefined)
      return false;
    var str = moment(val).format("yyyy-mm-dd")
    if (str == null || str == undefined)
      return false;

    return true;
  }
  checkString(val:string) {
    if (val == null || val == undefined)
      return false;
    else
        return true;
  }
  checkNum(val: number) {
    if (val == null || val == undefined)
      return false;
    else if (val > 0)
      return true;
    else
      return false;
  }

  back() {
    if (this.fromPage != "/reviews/manage")
      this.router.navigate([this.fromPage], {});
    else
      this.router.navigate(['reviews/manage'], { queryParams: { id: this.jobId, jobType: 2 } });
  }

  update() {
    //console.log(this.inspection);
    var msg = "";
    if (this.inspection.userId == null || this.inspection.userId == undefined)
      msg += "Please select the Techician" + "\n\r";

    if (!this.checkString(this.inspection.locationReference))
      msg += "Please enter a Location Reference" + "\n\r";

    if (this.editing && !this.checkString(this.inspection.reason_For_ReIssue))
      msg += "Please enter a Reason for Re-issue" + "\n\r";

    for (var i = 0; i < this.inspection.concretePours.length; i++) {
      var pour = this.inspection.concretePours[i];
      if (!this.checkDate(pour.pour_Date))
        msg += "Please enter a valid Date on line " + (i + 1) + "\n\r";
      if (!this.checkNum(pour.air_Temp))
        msg += "Please enter a valid Air Temp [°C] on line " + (i + 1) + "\n\r";
      if (!this.checkNum(pour.concrete_Temp))
        pour.concrete_Temp = 0;
        //msg += "Please enter a valid concrete Temp [°C] on line " + (i + 1) + "\n\r";
      if (!this.checkString(pour.delivery_Number))
        msg += "Please enter a valid Delivery Number on line " + (i + 1) + "\n\r";
      if (!this.checkNum(pour.weatherId))
        msg += "Please enter a valid Weather Condition on line " + (i + 1) + "\n\r";
      if (!this.checkNum(pour.compactionId))
        msg += "Please enter a valid Compaction Method on line " + (i + 1) + "\n\r";
      if (!this.checkNum(pour.amount_Poured))
        msg += "Please enter a valid Concrete per Truck [m³] on line " + (i + 1) + "\n\r";
      if (!this.checkString(pour.plant_Num))
        msg += "Please enter a valid Plant Used on line " + (i + 1) + "\n\r";
      if (!this.checkString(pour.concreteStrength))
        msg += "Please enter a valid Concrete Strength on line " + (i + 1) + "\n\r";
      if (!this.checkDate(pour.batchTime))
        msg += "Please enter a valid batch Time on line " + (i + 1) + "\n\r";
      if (!this.checkDate(pour.onSite))
        msg += "Please enter a valid On-Site Time on line " + (i + 1) + "\n\r";
      if (!this.checkDate(pour.startTime))
        msg += "Please enter a valid start Time on line " + (i + 1) + "\n\r";
      if (!this.checkDate(pour.endTime))
        msg += "Please enter a valid end Time on line " + (i + 1) + "\n\r";
      if (!this.checkDate(pour.cube_Set_Ref))
        msg += "Please enter a valid Cube Set Ref on line " + (i + 1) + "\n\r";

    }
    //console.log("msg");
    //console.log(msg);
    if (msg.length > 0) {
      this.snotifyService.error(msg);
      return;
    }
    var action = "";
    if (this.id == null || this.id == undefined)
      action = "saved";
    else
      action = "updated";
    //console.log(this.jobId);

    this.inspection.technician = null;
    this.inspection.job = null;

    if (this.inspection.jobId == null)
      this.inspection.jobId = this.jobId;


    this.concretePourService.post(this.inspection).then((data) => {
      this.snotifyService.success("Successfuly " + action + " inspection");
      this.back();
    });

  }

}
